import { Route, Routes } from 'react-router'
import { AddNumber } from 'pages/settings/pages/numbers/pages/AddNumber/ui/AddNumber'
import { AddNumberLayout } from 'pages/settings/pages/numbers/pages/AddNumber/layout/AddNumberLayout'
import { AddNumberAccessLayout } from 'pages/settings/pages/numbers/pages/AddNumber/layout/AddNumberAccessLayout'

export const AddNumberRouter = () => {
  return (
    <Routes>
      <Route element={<AddNumberAccessLayout />}>
        <Route element={<AddNumberLayout />}>
          <Route path={'/'} element={<AddNumber />} />
        </Route>
      </Route>
    </Routes>
  )
}
